(() => {
  'use strict';

  /* =========================================================
     SPIELGERÄTE4YOU – PDP STICKY ADD TO CART
     ========================================================= */

  const ROOT_SELECTOR = '[id^="MainProduct-"]';

  const SELECTORS = {
    title: '.product__title',

    originalButton:
      'form[data-type="add-to-cart-form"] .product-form__submit',

    originalButtonLabel:
      'form[data-type="add-to-cart-form"] .product-form__submit .button__label',

    priceSale:
      '.price-wrapper .price--on-sale .price-item--sale',

    priceRegular:
      '.price-wrapper .price__regular .price-item--regular',

    priceFallback:
      '.price-wrapper .price-item--regular',

    activeImage:
      '.product__media-item.swiper-slide-active img',

    selectedImage:
      '.product__media-item.active img',

    firstImage:
      '.product__media-item img',

    checkedOptions:
      'variant-radios input[type="radio"]:checked',

    stock:
      '.pdp-stock-text'
  };

  const instances = new WeakMap();


  /* =========================================================
     HELPERS
     ========================================================= */

  function cleanText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function getOriginalButton(root) {
    return root.querySelector(
      SELECTORS.originalButton
    );
  }


  function getTitle(root) {
    const element =
      root.querySelector(
        SELECTORS.title
      );

    return element
      ? cleanText(element.textContent)
      : '';
  }


  function getPrice(root) {
    const sale =
      root.querySelector(
        SELECTORS.priceSale
      );

    if (
      sale &&
      cleanText(sale.textContent)
    ) {
      return cleanText(
        sale.textContent
      );
    }


    const regular =
      root.querySelector(
        SELECTORS.priceRegular
      );

    if (
      regular &&
      cleanText(regular.textContent)
    ) {
      return cleanText(
        regular.textContent
      );
    }


    const fallback =
      root.querySelector(
        SELECTORS.priceFallback
      );

    return fallback
      ? cleanText(fallback.textContent)
      : '';
  }


  function getImage(root) {
    const image =
      root.querySelector(
        SELECTORS.activeImage
      ) ||
      root.querySelector(
        SELECTORS.selectedImage
      ) ||
      root.querySelector(
        SELECTORS.firstImage
      );

    if (!image) {
      return {
        src: '',
        alt: ''
      };
    }

    return {
      src:
        image.currentSrc ||
        image.src ||
        image.getAttribute('src') ||
        '',

      alt:
        image.getAttribute('alt') ||
        getTitle(root)
    };
  }


  function getSelectedOptions(root) {
    const inputs =
      root.querySelectorAll(
        SELECTORS.checkedOptions
      );

    const values = [];

    inputs.forEach((input) => {
      const value =
        cleanText(input.value);

      if (
        value &&
        !values.includes(value)
      ) {
        values.push(value);
      }
    });

    return values
      .slice(0, 2)
      .join(' · ');
  }


  function getStock(root) {
    const element =
      root.querySelector(
        SELECTORS.stock
      );

    return element
      ? cleanText(element.textContent)
      : '';
  }


  function getButtonLabel(root) {
    const label =
      root.querySelector(
        SELECTORS.originalButtonLabel
      );

    if (
      label &&
      cleanText(label.textContent)
    ) {
      return cleanText(
        label.textContent
      );
    }

    return 'In deinen Warenkorb →';
  }


  /* =========================================================
     CART DRAWER
     ========================================================= */

  function isElementVisible(element) {
    if (!element) return false;

    if (
      element.hidden ||
      element.getAttribute('aria-hidden') === 'true'
    ) {
      return false;
    }

    const style =
      window.getComputedStyle(element);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      Number(style.opacity) === 0
    ) {
      return false;
    }

    const rect =
      element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0
    );
  }


  /*
   * WICHTIG:
   * Ein Drawer gilt NICHT allein deshalb
   * als offen, weil er Maße im DOM besitzt.
   *
   * Viele Themes schieben den geschlossenen
   * Drawer nur per transform aus dem Viewport.
   */
  function hasExplicitOpenState(element) {
    if (!element) return false;


    if (
      element.tagName === 'DIALOG' &&
      element.hasAttribute('open')
    ) {
      return true;
    }


    if (element.hasAttribute('open')) {
      return true;
    }


    if (
      element.getAttribute('aria-hidden') === 'false'
    ) {
      return true;
    }


    const openClasses = [
      'active',
      'is-active',
      'open',
      'is-open',
      'opened',
      'drawer--active',
      'drawer--open',
      'menu-opening'
    ];


    return openClasses.some(
      (className) =>
        element.classList.contains(
          className
        )
    );
  }


  function isCartDrawerOpen() {
    const cartCandidates =
      document.querySelectorAll(
        [
          'cart-drawer',
          '#CartDrawer',
          '.cart-drawer',
          '[data-cart-drawer]',
          '[id*="cartdrawer" i]',
          '[id*="cart-drawer" i]',
          '[class*="cart-drawer" i]'
        ].join(',')
      );


    for (
      const element of cartCandidates
    ) {
      if (
        hasExplicitOpenState(element) &&
        isElementVisible(element)
      ) {
        return true;
      }
    }


    /*
     * Fallback für Themes mit generischem
     * dialog / drawer.
     */
    const dialogs =
      document.querySelectorAll(
        '[role="dialog"], dialog, .drawer'
      );


    for (
      const element of dialogs
    ) {
      const identifier = [
        element.id || '',
        typeof element.className === 'string'
          ? element.className
          : '',
        element.getAttribute('aria-label') || '',
        element.getAttribute('data-drawer') || ''
      ]
        .join(' ')
        .toLowerCase();


      const isCart =
        identifier.includes('cart') ||
        identifier.includes('warenkorb');


      if (
        isCart &&
        hasExplicitOpenState(element) &&
        isElementVisible(element)
      ) {
        return true;
      }
    }


    return false;
  }


  /* =========================================================
     CREATE STICKY BAR
     ========================================================= */

  function createStickyBar(root) {
    /*
     * Sicherheit gegen doppelte Instanzen.
     */
    const existing =
      document.querySelector(
        `.s4y-sticky-atc[data-product-root="${root.id}"]`
      );

    if (existing) {
      existing.remove();
    }


    const bar =
      document.createElement('div');


    bar.className =
      's4y-sticky-atc';


    bar.dataset.productRoot =
      root.id;


    bar.setAttribute(
      'aria-hidden',
      'true'
    );


    bar.innerHTML = `
      <div class="s4y-sticky-atc__inner">

        <div class="s4y-sticky-atc__media">
          <img
            class="s4y-sticky-atc__image"
            src=""
            alt=""
            width="80"
            height="80"
          >
        </div>

        <div class="s4y-sticky-atc__product">
          <span class="s4y-sticky-atc__title"></span>
          <span class="s4y-sticky-atc__subline"></span>
        </div>

        <div
          class="s4y-sticky-atc__price"
          aria-live="polite"
        ></div>

        <button
          type="button"
          class="s4y-sticky-atc__button"
        >
          <span
            class="s4y-sticky-atc__button-text"
          >
            In deinen Warenkorb →
          </span>
        </button>

      </div>
    `;


    document.body.appendChild(bar);


    document.body.classList.add(
      's4y-sticky-cart-ready'
    );


    return bar;
  }


  /* =========================================================
     SHOW / HIDE
     ========================================================= */

  function hideBar(bar) {
    if (!bar) return;


    bar.classList.remove(
      'is-visible'
    );


    bar.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      's4y-sticky-atc-visible'
    );
  }


  function showBar(bar) {
    if (!bar) return;


    bar.classList.add(
      'is-visible'
    );


    bar.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      's4y-sticky-atc-visible'
    );
  }


  /* =========================================================
     CONTENT SYNC
     ========================================================= */

  function syncBar(root, bar) {
    const originalButton =
      getOriginalButton(root);


    if (!originalButton) {
      return;
    }


    const title =
      bar.querySelector(
        '.s4y-sticky-atc__title'
      );


    const subline =
      bar.querySelector(
        '.s4y-sticky-atc__subline'
      );


    const price =
      bar.querySelector(
        '.s4y-sticky-atc__price'
      );


    const image =
      bar.querySelector(
        '.s4y-sticky-atc__image'
      );


    const stickyButton =
      bar.querySelector(
        '.s4y-sticky-atc__button'
      );


    const stickyButtonText =
      bar.querySelector(
        '.s4y-sticky-atc__button-text'
      );


    if (title) {
      title.textContent =
        getTitle(root);
    }


    if (price) {
      price.textContent =
        getPrice(root);
    }


    const productImage =
      getImage(root);


    if (
      image &&
      productImage.src
    ) {
      image.src =
        productImage.src;

      image.alt =
        productImage.alt;
    }


    const optionText =
      getSelectedOptions(root);


    const stockText =
      getStock(root);


    const sublineParts = [];


    if (optionText) {
      sublineParts.push(
        optionText
      );
    }


    if (stockText) {
      sublineParts.push(
        stockText
      );
    }


    if (subline) {
      subline.textContent =
        sublineParts.join(' · ');
    }


    if (stickyButtonText) {
      stickyButtonText.textContent =
        getButtonLabel(root);
    }


    const disabled =
      originalButton.disabled ||
      originalButton.hasAttribute(
        'disabled'
      );


    if (stickyButton) {
      stickyButton.disabled =
        disabled;


      stickyButton.classList.toggle(
        'is-loading',
        originalButton.classList.contains(
          'loading'
        )
      );
    }
  }


  /* =========================================================
     VISIBILITY
     ========================================================= */

  function updateVisibility(
    root,
    bar,
    state
  ) {
    const originalButton =
      getOriginalButton(root);


    if (!originalButton) {
      hideBar(bar);

      return;
    }


    const cartOpen =
      isCartDrawerOpen();


    document.body.classList.toggle(
      's4y-cart-drawer-open',
      cartOpen
    );


    if (cartOpen) {
      hideBar(bar);

      return;
    }


    if (
      state.suppressUntil &&
      Date.now() <
        state.suppressUntil
    ) {
      hideBar(bar);

      return;
    }


    const buttonRect =
      originalButton
        .getBoundingClientRect();


    /*
     * Originaler CTA befindet sich
     * aktuell im Viewport.
     */
    const buttonVisible =
      buttonRect.top <
        window.innerHeight &&
      buttonRect.bottom > 0;


    /*
     * Nicht sofort beim Laden anzeigen.
     *
     * Mobile etwas früher als Desktop.
     */
    const mobile =
      window.matchMedia(
        '(max-width: 749px)'
      ).matches;


    const minimumScroll =
      mobile
        ? 160
        : 220;


    const shouldShow =
      window.scrollY >
        minimumScroll &&
      !buttonVisible;


    if (shouldShow) {
      showBar(bar);
    } else {
      hideBar(bar);
    }
  }


  /* =========================================================
     INIT
     ========================================================= */

  function init(root) {
    if (
      !root ||
      instances.has(root)
    ) {
      return;
    }


    const originalButton =
      getOriginalButton(root);


    if (!originalButton) {
      return;
    }


    const bar =
      createStickyBar(root);


    const state = {
      suppressUntil: 0
    };


    let rafRunning = false;


    function requestUpdate() {
      if (rafRunning) {
        return;
      }


      rafRunning = true;


      window.requestAnimationFrame(
        () => {
          rafRunning = false;


          syncBar(
            root,
            bar
          );


          updateVisibility(
            root,
            bar,
            state
          );
        }
      );
    }


    /* =======================================================
       STICKY BUTTON
       ======================================================= */

    const stickyButton =
      bar.querySelector(
        '.s4y-sticky-atc__button'
      );


    function handleStickyClick() {
      const currentButton =
        getOriginalButton(root);


      if (
        !currentButton ||
        currentButton.disabled ||
        currentButton.hasAttribute(
          'disabled'
        )
      ) {
        return;
      }


      hideBar(bar);


      /*
       * verhindert kurzes Wiederauftauchen,
       * während der Cart Drawer öffnet
       */
      state.suppressUntil =
        Date.now() + 2500;


      /*
       * Wir verwenden weiterhin den
       * ORIGINAL Shopify Add-to-Cart Button.
       */
      currentButton.click();


      [
        80,
        250,
        600,
        1200,
        2700
      ].forEach((delay) => {
        window.setTimeout(
          requestUpdate,
          delay
        );
      });
    }


    stickyButton?.addEventListener(
      'click',
      handleStickyClick
    );


    /* =======================================================
       VARIANT CHANGE
       ======================================================= */

    function variantChanged() {
      [
        50,
        250,
        700
      ].forEach((delay) => {
        window.setTimeout(
          requestUpdate,
          delay
        );
      });
    }


    root.addEventListener(
      'change',
      variantChanged
    );


    root.addEventListener(
      'input',
      variantChanged
    );


    /* =======================================================
       SCROLL + RESIZE
       ======================================================= */

    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      requestUpdate,
      {
        passive: true
      }
    );


    /* =======================================================
       PRODUCT OBSERVER
       ======================================================= */

    const productObserver =
      new MutationObserver(
        requestUpdate
      );


    productObserver.observe(
      root,
      {
        childList: true,
        subtree: true,
        characterData: true,

        attributes: true,

        attributeFilter: [
          'disabled',
          'class',
          'value',
          'src'
        ]
      }
    );


    /* =======================================================
       BODY OBSERVER
       ======================================================= */

    const bodyObserver =
      new MutationObserver(
        requestUpdate
      );


    bodyObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true,

        attributes: true,

        attributeFilter: [
          'class',
          'open',
          'aria-hidden'
        ]
      }
    );


    /* =======================================================
       CART CLOSE / ESC
       ======================================================= */

    document.addEventListener(
      'keydown',
      requestUpdate
    );


    document.addEventListener(
      'click',
      requestUpdate,
      true
    );


    /* =======================================================
       INITIAL
       ======================================================= */

    syncBar(
      root,
      bar
    );


    updateVisibility(
      root,
      bar,
      state
    );


    instances.set(
      root,
      {
        bar,
        state,

        stickyButton,
        handleStickyClick,

        productObserver,
        bodyObserver,

        requestUpdate,
        variantChanged
      }
    );
  }


  /* =========================================================
     DESTROY
     ========================================================= */

  function destroy(root) {
    const instance =
      instances.get(root);


    if (!instance) {
      return;
    }


    instance.productObserver?.disconnect();
    instance.bodyObserver?.disconnect();


    window.removeEventListener(
      'scroll',
      instance.requestUpdate
    );


    window.removeEventListener(
      'resize',
      instance.requestUpdate
    );


    document.removeEventListener(
      'keydown',
      instance.requestUpdate
    );


    document.removeEventListener(
      'click',
      instance.requestUpdate,
      true
    );


    root.removeEventListener(
      'change',
      instance.variantChanged
    );


    root.removeEventListener(
      'input',
      instance.variantChanged
    );


    instance.stickyButton
      ?.removeEventListener(
        'click',
        instance.handleStickyClick
      );


    instance.bar?.remove();


    instances.delete(root);


    if (
      document.querySelectorAll(
        '.s4y-sticky-atc'
      ).length === 0
    ) {
      document.body.classList.remove(
        's4y-sticky-cart-ready',
        's4y-sticky-atc-visible',
        's4y-cart-drawer-open'
      );
    }
  }


  /* =========================================================
     INIT ALL
     ========================================================= */

  function initAll(
    scope = document
  ) {
    if (
      scope.matches?.(
        ROOT_SELECTOR
      )
    ) {
      init(scope);

      return;
    }


    scope
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(init);
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll();
      },
      {
        once: true
      }
    );
  } else {
    initAll();
  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      window.setTimeout(
        () => {
          initAll(
            event.target
          );
        },
        100
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const roots =
        event.target.matches?.(
          ROOT_SELECTOR
        )
          ? [event.target]
          : event.target.querySelectorAll(
              ROOT_SELECTOR
            );


      roots.forEach(
        destroy
      );
    }
  );

})();